const initialState = {};

export const batchReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};
